import { Box, Text, useColorModeValue } from "@chakra-ui/react";

export const Footer = () => {
  const container = useColorModeValue("white", "gray.900");
  const borderBottom = useColorModeValue("rgb(0 0 0 / 7%)", "rgb(0 0 0 / 30%)");

  return (
    <Box
      bgColor={container}
      textAlign="right"
      py="1"
      px="3"
      borderTop={`1px solid ${borderBottom}`}
    >
      <Text fontSize="xs">
        Ouvidoria - EGL Engenharia
      </Text>
    </Box>
  );
};
